import React from 'react';

class Cities extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            results: []
        };

        this._cancelSearch = this._cancelSearch.bind(this);
        this._handleSearch = this._handleSearch.bind(this);

        this.handleChange = this.handleChange.bind(this);
        this.handleClear = this.handleClear.bind(this);
    }

    componentWillUnmount() {
        this._cancelSearch();
    }

    _cancelSearch() {
        if (this.searchRequest) {
            this.searchRequest.abort();
            this.searchRequest = null;
        }
    }

    _handleSearch(term) {
        const component = this;
        component._cancelSearch();

        if (term == null || !term.length) {
            component.setState({
                results: [],
                term: ''
            });
            return;
        }
        component.setState({
            loading: true,
            term: term
        });
        component.searchRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.cities.get(term),
            null,
            function (responseData) {
                component.searchRequest = null;

                let results = responseData.Data || [];
                if (results.length) {
                    const regex = new RegExp(term, 'ig');
                    results = results.map(function (city) {
                        const display = city.Name.replace(regex, '<strong>' + term + '</strong>');
                        return { display: display, name: city.Name };
                    });
                }
                component.setState({
                    loading: false,
                    results: results
                });
            },
            function (jqXHR, textStatus) {
                component.searchRequest = null;
                component.setState({
                    loading: false
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    handleChange(event) {
        this._handleSearch(event.currentTarget.value);
    }

    handleClear(event) {
        if (event) {
            event.preventDefault();
        }
        this._handleSearch(null);
    }

    render() {
        let className = 'dropdown--cities__search';
        let results;
        const term = this.state.term || '';
        if (term.length) {
            className += ' dropdown--cities__search--clear';

            const data = this.state.results || [];
            if (!this.state.loading && !data.length) {
                results = <a href="#">No results</a>;
            } else {
                results = data.map(function (city) {
                    return <a key={city.name} href={`/city/${city.name}`} dangerouslySetInnerHTML={{ __html: city.display }}></a>
                });
            }
        } else {
            results = (
                <React.Fragment>
                    <a href="/city/Atlanta-GA">Atlanta</a>
                    <a href="/city/NewYork-NY">New York</a>
                    <a href="/city/SanFrancisco-CA">San Francisco</a>
                    <a href="/city/Dallas-TX">Dallas</a>
                    <a href="/city/SantaFe-NM">Santa Fe</a>
                    <a href="/city/LasVegas-NV">Los Angeles</a>
                    <a href="/city/Miami-FL">Miami</a>
                </React.Fragment>
            )
        }
        let containerClassName = 'dropdown--cities';
        if (this.props.split) {
            containerClassName += ' dropdown--cities__split';
        }
        return (
            <div className={containerClassName}>
                <div className="dropdown--cities__bg" />
                <span className="dropdown--cities__anchor">Cities <span className="i i--arrow-bottom" /></span>
                <div className="dropdown--cities__content">
                    <div className={className}>
                        <input className="dropdown--cities__search__input"
                            placeholder="Search for a specific city..."
                            type="text"
                            value={term}
                            onChange={this.handleChange} />
                        <span className="dropdown--cities__search__icon">
                            <span className="i i--search"></span>
                            <a href="#" onClick={this.handleClear}><span className="i i--outline-close" /></a>
                        </span>
                    </div>
                    <div className="dropdown--cities__results">
                        {results}
                    </div>
                </div>
            </div>
        );
    }
}

class Select extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleClick = this.handleClick.bind(this);
        this.handleOptionSelect = this.handleOptionSelect.bind(this);
    }

    handleClick() {
        this.setState({
            active: true
        });
    }

    handleOptionSelect(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.props.onOptionSelect && event.currentTarget.attributes.value) {
            const value = parseInt(event.currentTarget.attributes.value.value);
            this.props.onOptionSelect(this.props.name, value);
        }
        this.setState({
            active: false
        });
    }

    render() {
        let options = [];
        if (this.props.options) {
            const component = this;
            options = component.props.options.map(function (d) {
                return (
                    <a key={d.value}
                        className="dropdown--select__opt"
                        href="#"
                        value={d.value}
                        onClick={component.handleOptionSelect}>
                        {d.display}
                    </a>
                );
            });
        }
        let className = 'input__container input--dd dropdown--fullwidth dropdown--select input--medium input--outline input--light';
        if (this.state.active) {
            className += ' dropdown--select--active';
        }
        return (
            <div className={className}>
                <span className="input--dd__anchor dropdown--select__anchor dropdown--select__anchor__type" onClick={this.handleClick}>{this.props.display}</span>
                <span className="i i--arrow-bottom"></span>
                <div className="dropdown__box">
                    {options}
                </div>
            </div>
        );
    }
}

export {
    Cities,
    Select
};